export class PageConfig {
	public defaults: any = {
		dashboard: {
			page: {
				title: 'DASHBOARD.PAGE.TITLE',
			},
		},
		thirdparties: {
			list: {
				page: {
					title: 'THIRDPARTIES.PAGE.TITLE'
				}
			},
			detail: {
				page: {
					title: 'THIRDPARTY.PAGE.TITLE'
				}
			},
			tags:{
				page: {
					title: 'THIRDPARTIES.PAGE.TAGS.TITLE'
				}
			},
			evaluation: {
				start:{
					page: {
						title: 'THIRDPARTIES.PAGE.EVALUATION.START'
					}
				},
				continue:{
					page: {
						title: 'THIRDPARTIES.PAGE.EVALUATION.CONTINUE'
					}
				},
				explore:{
					page: {
						title: 'THIRDPARTIES.PAGE.EVALUATION.EXPLORE'
					}
				},
				'reply-questionnaire':{
					page: {
						title: 'THIRDPARTIES.PAGE.EVALUATION.REPLYQUESTIONNAIRE',
					}
				},
				'confirm-questionnaire':{
					page: {
						title: 'THIRDPARTIES.PAGE.EVALUATION.CONFIRMQUESTIONNAIRE',
					}
				},
				'explore-questionnaire':{
					page: {
						title: 'THIRDPARTIES.PAGE.EVALUATION.EXPLOREQUESTIONNAIRE',
					}
				},
				'complete-due-diligence':{
					page: {
						title: 'THIRDPARTIES.PAGE.EVALUATION.COMPLETE_DUEDILIGENCE',
					}
				}
			},
			"evaluation-score-result": {
				page: {
					title: 'SCORE_PAGE.PAGE.TITLE'
				}
			}
		},
		'import-thirdparty': {
			list: {
				page: {
					title: 'IMPORT-THIRDPARTY.PAGE.LIST-TITLE',
				}
			},
			'imported-file': {
				page: {
					title: 'IMPORT-THIRDPARTY.PAGE.FILE-TITLE',
				}
			}
		},
		evaluations: {
			tray: {
				page: {
					title: 'EVALUATIONTRAY.PAGE.TITLE',
				}
			},
			"approvement-review": {
				page: {
					title: 'EVALUATIONTRAY.PAGE.TITLE_REVIEW'
				}
			}
		},
		'survey': {
			inbox: {
				page: {
					title: 'SURVEY.PAGE.TITLE',
				}
			},
			"leader-inbox": {
				page: {
					title: 'SURVEY.PAGE.LEADER_TITLE',
				}
			},
			"auditor-inbox": {
				page: {
					title: 'SURVEY.PAGE.AUDITOR_TITLE',
				}
			}
		},
		questionnaires: {
			tray: {
				page: {
					title: 'QUESTIONNAIRETRAY.PAGE.TITLE',
				}
			}
		},
		"thirdparty-tracing-tasks": {
			"list": {
				page: {
					title: 'THIRDPARTY_TRACING_TASKS.TITLE',
				}
			},
			"result": {
				page: {
					title: 'THIRDPARTY_TRACING_TASKS.RESULT.TITLE',
				}
			}
		},
		"due-diligence": {
			"outgoing-tray": {
				page: {
					title: 'DUEDILIGENCE_CLIENT.PAGE.TITLE'
				}
			},
			"incoming-tray": {
				page: {
					title: 'DUEDILIGENCE_PROVIDER.PAGE.TITLE'
				}
			},
			"request-form": {
				page: {
					title: 'DUEDILIGENCE_REQUEST_FORM.PAGE.TITLE'
				}
			}
		},
		tracing: {
			tray:{
				page: {
					title: 'TRACING_TRAY.PAGE.TITLE'
				}
			},
			'plan-detail':{
				page: {
					title: 'TRACING_PLAN_DETAIL.PAGE.TITLE'
				}
			},
			'task-detail':{
				page: {
					title: 'TRACING_TASK_DETAIL.PAGE.TITLE'
				}
			}
		},
		reports: {
			evaluations:{
				page: {
					title: 'EVALUATION-REPORTS.HEADER.TITLE'
				}
			},
			'follow-up':{
				page: {
					title: 'FOLLOW_UP-REPORTS.HEADER.TITLE'
				}
			},
			surveys:{
				page: {
					title: 'SURVEY-REPORTS.HEADER.TITLE'
				}
			},
			comercial:{
				page: {
					title: 'COMMERCIAL-REPORTS.HEADER.TITLE'
				}
			},
			grc:{
				page: {
					title: 'GRC-REPORTS.HEADER.TITLE'
				}
			}
		},
		launches: {
			list:{
				page: {
					title: 'LAUNCHES.HEADER.TITLE'
				}
			},
			'create-launch':{
				page: {
					title: 'LAUNCHES.HEADER.CREATE-TITLE'
				}
			},
			'edit-launch':{
				page: {
					title: 'LAUNCHES.HEADER.EDIT-TITLE'
				}
			},
			'copy-launch':{
				page: {
					title: 'LAUNCHES.HEADER.COPY-TITLE'
				}
			},
			'view-launch':{
				page: {
					title: 'LAUNCHES.HEADER.VIEW-TITLE'
				}
			}
		},
		"survey-warnings": {
			list:{
				page: {
					title: 'SURVEY-WARNINGS.HEADER.TITLE'
				}
			},
			'view-survey-observations':{
				page: {
					title: 'SURVEY-WARNINGS.HEADER.OBSERVATIONS-PAGE'
				}
			},
		},
        "unauthorized-inside": {
            page: { title: 'AUTH.ERROR.UNAUTHORIZED_TITLE' }
        },
		error: {
			404: {
				page: {title: '404 Not Found', subheader: false}
			},
			403: {
				page: {title: '403 Access Forbidden', subheader: false}
			}
		}
	};

	public get configs(): any {
		return this.defaults;
	}
}
